<script lang="ts">
import {Vue, Component} from 'vue-facing-decorator';
import NavBar from "@/component/common/NavBar.vue";
import SkillsComponent from "@/component/SkillsComponent.vue";

@Component({
  components: {
    SkillsComponent, 
    NavBar
  }
})
export default class SkillsView extends Vue {
  mounted() {
    window.scrollTo(0, 0);
  }
}
</script>

<template>
  <div class="infra-layout">
    <NavBar/>
    
    <main class="layer-page">
      <SkillsComponent/>
    </main>
  </div>
</template>

<style scoped>
@import "@/assets/styles/infra-layers.css";

.layer-page {
  padding-top: 2rem;
  width: 100%;
  max-width: var(--ln-content-max-width);
  margin: 0 auto;
}

@media (max-width: 768px) {
  .layer-page {
    padding: 1rem;
  }
}
</style>
